import React from 'react'
import "./Beverages.css"

const Beverages = () => {
  return (
    <div>
        <h1 style={{marginTop:"50px"}}>Beverages</h1>
    <div className='Beverages'>
        <div >
            <img style={{height:"450px",cursor:"pointer"}} src="https://www.bigbasket.com/media/customPage/77880b23-0233-4fad-b54a-a93c998e0d20/7f6ddfd5-93af-4bbd-a250-ce828daa63d6/c9120807-7db5-4f39-9895-3b03dee91c54/hp_hot-sips-beveragesStorefront_m_251022_560x378_01.jpg" alt="Not-Found" />
        </div>
        <div>
            <div >
                <img style={{height:"203px",cursor:"pointer"}}  src="https://www.bigbasket.com/media/customPage/77880b23-0233-4fad-b54a-a93c998e0d20/7f6ddfd5-93af-4bbd-a250-ce828daa63d6/c9120807-7db5-4f39-9895-3b03dee91c54/hp_coost-beveragesStorefront_m_251022_275x184_02.jpg" alt="Not-Found" />
                <img style={{height:"203px",cursor:"pointer"}} src="https://www.bigbasket.com/media/customPage/77880b23-0233-4fad-b54a-a93c998e0d20/7f6ddfd5-93af-4bbd-a250-ce828daa63d6/c9120807-7db5-4f39-9895-3b03dee91c54/hp_coffee-beveragesStorefront_m_251022_275x184_03.jpg" alt="Not-Found" />
            </div>
            <div >
                <img style={{height:"203px",cursor:"pointer"}} src="https://www.bigbasket.com/media/customPage/77880b23-0233-4fad-b54a-a93c998e0d20/7f6ddfd5-93af-4bbd-a250-ce828daa63d6/c9120807-7db5-4f39-9895-3b03dee91c54/hp_health-beveragesStorefront_m_251022_275x184_04.jpg" alt="Not-Found" />
                <img style={{height:"203px",cursor:"pointer"}} src="https://www.bigbasket.com/media/customPage/77880b23-0233-4fad-b54a-a93c998e0d20/7f6ddfd5-93af-4bbd-a250-ce828daa63d6/c9120807-7db5-4f39-9895-3b03dee91c54/hp_energy-beveragesStorefront_m_251022_275x184_05.jpg" alt="Not-Found" />
            </div>
        </div>
    </div>
    </div>
  )
}

export default Beverages